// eslint-disable-next-line no-shadow
enum OrderItemType {
  TICKET,
  PRODUCT,
}
export default OrderItemType;
